// import React, { useState, useRef, useEffect, useCallback } from "react";
// import { Truck, Package, Calendar, Clock, CalendarClock, X, Lock } from "lucide-react";
// import { format, parseISO, isValid } from 'date-fns';
// import axios from "axios";
// import Cookies from "js-cookie";
// import Loader from "../../../../../components/ACS-Dashboard/ACS-Blocks/Loader";
// import { useDispatch, useSelector } from "react-redux";
// import {
//   removeTab,
//   setActiveTab,
//   setLastSelectedLocation,
//   setLastSelectedWarehouse,
// } from "../../../../../redux/slices/appointmentsSlices";
// import StickyHeader from "../../../../../components/ModuleCommon/StickyHeader/StickyHeader";
// import { fetchLocationByRef, fetchDockById, fetchWarehouseSlotsAvailability, getShipmentByShipmentNum } from "../api/AppointmentsApi";
// import { ExpandableHeader } from "../../../../../components/ACS-Dashboard/ACS-Blocks/ExpandableHeader";
// import { DisplayDetail } from "../../../../../components/ACS-Dashboard/ACS-Blocks/DisplayDetail";
// import notify from "../../../../../components/ACS-Dashboard/ACS-Blocks/Toast";
// import { addTab as addShipmentTab } from "../../../../../redux/slices/shipmentSlice";
// import { useNavigate } from "react-router-dom";

// /**
//  * AppointmentForm
//  *
//  * Props:
//  *  - appointmentData  : object  — appointment record to display / edit
//  *  - userType         : string  — "Shipper" | "Carrier" | …
//  *  - mode             : string  — "update" | "add" | "readonly"
//  *                        "readonly" disables all inputs, hides action buttons,
//  *                        and shows a read-only banner.
//  */
// const AppointmentForm = ({ appointmentData, userType, mode = "update" }) => {
//   const dispatch = useDispatch();
//   const { activeTab, lastSelectedLocation, lastSelectedWarehouse } = useSelector(
//     (state) => state.appointments
//   );
//   const navigate = useNavigate();
//   const officeCode = Cookies.get("officeCode");
//   const [shipmentData, setShipmentData]             = useState(null);

//   // ── Mode flags ──────────────────────────────────────────────────────────────
//   const isAddMode      = mode === "add";
//   const isReadOnlyMode = mode === "readonly" || shipmentData?.status === "Active";
//   // isEditMode is true for both "update" and "add" modes (but NOT "readonly")
//   const isEditMode     = !isReadOnlyMode;

//   // Refs
//   const inputRef             = useRef(null);
//   const headerRef            = useRef(null);
//   const shouldFetchSlotsRef  = useRef(true);
//   const slotsFetchIdRef      = useRef(0);
//   const allSlotsFetchIdRef   = useRef(0);

//   const [loading, setLoading] = useState(false);
//   const isShipper = userType === "Shipper";
//   const warehouseFieldType = isShipper ? (isEditMode ? "dropdown" : "text") : "text";

//   // Location & Warehouse state
//   const [locationQuery, setLocationQuery]       = useState("");
//   const [locationOptions, setLocationOptions]   = useState([]);
//   const [selectedLocation, setSelectedLocation] = useState(null);
//   const [warehouseQuery, setWarehouseQuery]     = useState("");
//   const [warehouseOptions, setWarehouseOptions] = useState([]);
//   const [filteredWarehouses, setFilteredWarehouses] = useState([]);
//   const [selectedWarehouse, setSelectedWarehouse]   = useState(null);

//   // Docks & Doors state
//   const [dockQuery, setDockQuery]         = useState("");
//   const [dockOptions, setDocksOptions]    = useState([]);
//   const [selectedDocks, setSelectedDocks] = useState(null);
//   const [doorQuery, setDoorQuery]         = useState("");
//   const [doorOptions, setDoorOptions]     = useState([]);
//   const [selectedDoor, setSelectedDoor]   = useState(null);

//   // Appointment state
//   const [date, setDate]                           = useState(appointmentData?.startTime?.split("T")[0] || "");
//   const [slots, setSlots]                         = useState([]);
//   const [selectedSlot, setSelectedSlot]           = useState(null);
//   const [showAllSlotsModal, setShowAllSlotsModal] = useState(false);
//   const [allDockSlots, setAllDockSlots]           = useState([]);
//   const [isAllSlotsLoading, setIsAllSlotsLoading] = useState(false);
//   const [allSlotsError, setAllSlotsError]         = useState(null);
//   const [showInlineAllSlots, setShowInlineAllSlots] = useState(true);
//   const [selectedShipmentNumber, setSelectedShipmentNumber] = useState(
//     appointmentData?.shipmentNumber || ""
//   );

//   const isCancelled =
//     appointmentData?.cancelled ||
//     appointmentData?.status === "CANCELLED" ||
//     appointmentData?.fetchError === "not_found";

//   useEffect(() => {
//     if (!appointmentData?.startTime) return;
//     setDate(appointmentData.startTime.split("T")[0]);
//   }, [appointmentData?.startTime]);

//   // Shipments state
//   const [shipments, setShipments] = useState(
//     appointmentData
//       ? [{
//           shipmentNumber:   appointmentData.shipmentNumber   || "",
//           stopNumber:       appointmentData.stopNumber       || 1,
//           company:          appointmentData.shipperName      || appointmentData.companyName || appointmentData.company || "",
//           addressLine1:     appointmentData.addressLine1     || "",
//           addressLine2:     appointmentData.addressLine2     || "",
//           city:             appointmentData.city             || "",
//           zipCode:          appointmentData.zipCode          || "",
//           country:          appointmentData.country          || "",
//           state:            appointmentData.state            || "",
//           carrierName:      appointmentData.carrierName      || "",
//           officeCodeCarrier:appointmentData.carrierOfficeCode|| "",
//           officeCodeShipper:appointmentData.shipperOfficeCode|| "",
//           poNumber:         appointmentData.poNumber         || "",
//           saleNumber:       appointmentData.saleNumber       || "",
//           stopReasonCode:   appointmentData.stopReasonCode   || "",
//           mustPickUpBy:     appointmentData.pickupDate       || "",
//           mustDeliverBy:    appointmentData.deliveryDate     || "",
//         }]
//       : [{
//           shipmentNumber: "", stopNumber: 1, company: "",
//           addressLine1: "", addressLine2: "", city: "", zipCode: "",
//           country: "", state: "", carrierName: "", officeCodeCarrier: "",
//           officeCodeShipper: "", poNumber: "", saleNumber: "",
//           stopReasonCode: "", mustPickUpBy: "", mustDeliverBy: "",
//         }]
//   );

//   const [appointmentCarrier, setAppointmentCarrier] = useState({
//     driverName:    appointmentData?.driverName    || "",
//     carrierName:   appointmentData?.carrierName   || "",
//     trailerNumber: appointmentData?.trailerNumber || "",
//   });

//   const [availableShipments, setAvailableShipments] = useState([]);

//   // Pull a stop reason from shipment data using a stop number hint
//   const extractStopReasonFromShipmentData = (data, stopNumberHint) => {
//     if (!data?.shipmentStops?.length) return null;
//     const stopNum = Number(stopNumberHint ?? appointmentData?.stopNumber);
//     const matched =
//       data.shipmentStops.find(
//         (s) =>
//           (s.stopSequence != null && Number(s.stopSequence) === stopNum) ||
//           (s.stopNumber   != null && Number(s.stopNumber)   === stopNum)
//       ) || data.shipmentStops[0];
//     return matched?.stopReasonCode || matched?.stopReasonName || null;
//   };

//   // Sticky Header InfoData state
//   const [infoData, setInfoData] = useState(() => ({
//     Location: {
//       type: "text",
//       label: "Location",
//       value: selectedLocation?.locationName || "—",
//       options: locationOptions.map(loc => loc.locationName),
//       readonly: true,
//     },
//     Warehouse: {
//       type: warehouseFieldType,
//       label: "Warehouse",
//       value: selectedWarehouse?.locationName || "—",
//       options: warehouseOptions.map(wh => wh.locationName),
//       readonly: !isShipper,
//     },
//     "Appointment Date": {
//       type: isEditMode ? "date" : "text",
//       label: "Appointment Date",
//       value: date ? format(date, "MMM dd, yyyy") : "—",
//       readonly: false,
//     },
//   }));

//   // Carrier Field config
//   const [carrierFieldConfig, setCarrierFieldConfig] = useState({
//     carrierName:   { label: "Carrier Name",   value: appointmentData?.carrierName   || "", inputType: "text", isReadOnly: true  },
//     driverName:    { label: "Driver Name",    value: appointmentData?.driverName    || "", inputType: "text"                    },
//     trailerNumber: { label: "Trailer Number", value: appointmentData?.trailerNumber || "", inputType: "text"                    },
//   });

//   useEffect(() => {
//     setCarrierFieldConfig({
//       carrierName:   { label: "Carrier Name",   value: appointmentCarrier.carrierName,   inputType: "text", isReadOnly: true },
//       driverName:    { label: "Driver Name",    value: appointmentCarrier.driverName,    inputType: "text"                   },
//       trailerNumber: { label: "Trailer Number", value: appointmentCarrier.trailerNumber, inputType: "text"                   },
//     });
//   }, [appointmentCarrier]);

//   // Format slot times in 12-hour format
//   const formatSlotTime = (timeStr) => {
//     if (!timeStr) return "—";
//     const [h, m] = timeStr.split(":");
//     const d = new Date();
//     d.setHours(Number(h) || 0, Number(m) || 0, 0, 0);
//     return format(d, "h:mm a");
//   };

//   const currentDockDisplay = (() => {
//     if (selectedDocks?.dockName) return selectedDocks.dockName;
//     const match = dockOptions.find(
//       (d) => String(d.dockId) === String(appointmentData?.dockNumber)
//     );
//     return match?.dockName || appointmentData?.dockNumber || "N/A";
//   })();

//   // ── Slot selection — no-op in read-only mode ────────────────────────────────
//   const handleSelectInlineSlot = (dock, slot, slotsForDock) => {
//     if (isReadOnlyMode) return;
//     setSelectedDocks(dock);
//     setDockQuery(dock?.dockName || "");
//     setSelectedSlot(slot);
//     if (Array.isArray(slotsForDock)) setSlots(slotsForDock);
//   };

//   useEffect(() => {
//     if (selectedLocation) {
//       dispatch(setLastSelectedLocation({
//         id: selectedLocation.id || selectedLocation.uid,
//         locationRef: selectedLocation.locationRef || selectedLocation.id,
//         locationName: selectedLocation.locationName,
//       }));
//     }
//   }, [selectedLocation, dispatch]);

//   useEffect(() => {
//     if (selectedWarehouse) {
//       dispatch(setLastSelectedWarehouse({
//         id: selectedWarehouse.id || selectedWarehouse.uid || selectedWarehouse.locationRef,
//         locationRef: selectedWarehouse.locationRef,
//         locationName: selectedWarehouse.locationName,
//       }));
//     }
//   }, [selectedWarehouse, dispatch]);

//   useEffect(() => {
//     if (appointmentData || !lastSelectedLocation || selectedLocation) return;
//     if (!locationOptions.length) return;
//     const matched = locationOptions.find(
//       (loc) =>
//         loc.uid          === lastSelectedLocation.id ||
//         loc.id           === lastSelectedLocation.id ||
//         loc.locationName === lastSelectedLocation.locationName
//     );
//     if (matched) { setSelectedLocation(matched); setLocationQuery(matched.locationName); }
//   }, [appointmentData, lastSelectedLocation, selectedLocation, locationOptions]);

//   useEffect(() => {
//     if (appointmentData || !selectedLocation || !lastSelectedWarehouse || selectedWarehouse) return;
//     if (!warehouseOptions.length) return;
//     const matched = warehouseOptions.find(
//       (wh) =>
//         wh.locationRef  === lastSelectedWarehouse.locationRef ||
//         wh.locationName === lastSelectedWarehouse.locationName
//     );
//     if (matched) { setSelectedWarehouse(matched); setWarehouseQuery(matched.locationName); }
//   }, [appointmentData, selectedLocation, lastSelectedWarehouse, selectedWarehouse, warehouseOptions]);

//   // Utility functions
//   const trimTime = (isoTime) => isoTime?.split("T")[1]?.split(".")[0];

//   const formattedTime = (isoTime, formatStr = 'yyyy-MM-dd HH:mm:ss') => {
//     if (typeof isoTime !== 'string') return null;
//     const parsed = parseISO(isoTime);
//     if (!isValid(parsed)) return null;
//     return format(parsed, formatStr);
//   };

//   const formatDateOnly = (isoTime, formatStr = 'yyyy-MM-dd') => {
//     if (typeof isoTime !== 'string') return null;
//     const parsed = parseISO(isoTime);
//     if (!isValid(parsed)) return null;
//     return format(parsed, formatStr);
//   };

//   const deriveTypeInfo = () => {
//     const stopReason = (
//       appointmentData?.stopReasonCode ||
//       extractStopReasonFromShipmentData(shipmentData, appointmentData?.stopNumber) ||
//       ""
//     ).trim().toUpperCase();

//     const requestTypeRaw = (
//       appointmentData?.requestType || shipmentData?.requestType || ""
//     ).trim().replace("_", " ").replace("-", " ").toUpperCase();

//     const stopIsDT =
//       stopReason === "DT" || stopReason === "DROP TRAILER" || stopReason === "DROPTRAILER" ||
//       (stopReason.includes("DROP") && stopReason.includes("TRAILER"));

//     const requestIsDT =
//       requestTypeRaw === "DT" || requestTypeRaw === "DROP TRAILER" || requestTypeRaw === "DROPTRAILER" ||
//       (requestTypeRaw.includes("DROP") && requestTypeRaw.includes("TRAILER"));

//     const isDropTrailer =
//       appointmentData?.isDropTrailer ?? requestIsDT ?? stopIsDT;

//     return {
//       isDropTrailer: Boolean(isDropTrailer),
//       label: isDropTrailer ? "Drop Trailer" : "Live Load",
//     };
//   };

//   // ── Info change — no-op in read-only mode ───────────────────────────────────
//   const handleInfoChange = (field, newValue) => {
//     if (isReadOnlyMode) return;

//     if (field === "Appointment Date") {
//       const mustPickUpBy = formatDateOnly(shipmentData?.pickupDate);
//       if (mustPickUpBy && mustPickUpBy !== "—" && newValue < mustPickUpBy) {
//         notify.warning({
//           title: "Invalid Date",
//           message: `The appointment date cannot be before the Planned Pickup Date (${format(parseISO(mustPickUpBy), "MMM dd, yyyy")}).`,
//         });
//         return;
//       }
//     }

//     setInfoData((prev) => ({ ...prev, [field]: { ...prev[field], value: newValue } }));

//     if (field === "Location") {
//       const selected = locationOptions.find(loc => loc.locationName === newValue);
//       if (selected) { setSelectedLocation(selected); setLocationQuery(selected.locationName); }
//     }

//     if (field === "Warehouse") {
//       const selected = warehouseOptions.find(wh => wh.locationName === newValue);
//       if (selected) {
//         setSelectedWarehouse(selected);
//         setWarehouseQuery(selected.locationName);
//         setSelectedDocks(null);
//         setDockQuery("");
//         setSelectedSlot(null);
//         setSlots([]);
//         setShowInlineAllSlots(true);
//         setShowAllSlotsModal(false);
//         setAllDockSlots([]);
//       }
//     }

//     if (field === "Appointment Date") setDate(newValue);
//   };

//   // Update infoData when dependencies change
//   useEffect(() => {
//     const stop = shipmentData?.shipmentStops?.find(
//       (s) => s.stopName === selectedLocation?.locationName
//     );
//     const mustPickUpBy   = formatDateOnly(stop?.scheduledGateIn) ?? "—";
//     const today          = format(new Date(), 'yyyy-MM-dd');
//     const calculatedMinDate = (() => {
//       if (mustPickUpBy && mustPickUpBy !== "—") {
//         return mustPickUpBy > today ? mustPickUpBy : today;
//       }
//       return today;
//     })();

//     setInfoData((prev) => ({
//       ...prev,
//       Location: {
//         ...prev.Location,
//         value: selectedLocation?.locationName || "—",
//         options: locationOptions.map(loc => loc.locationName),
//         // In read-only mode every header field is read-only
//         readonly: isReadOnlyMode ? true : prev.Location.readonly,
//       },
//       Warehouse: {
//         ...prev.Warehouse,
//         value: selectedWarehouse?.locationName || "—",
//         type:  isReadOnlyMode ? "text" : warehouseFieldType,
//         options: warehouseOptions.map(wh => wh.locationName),
//         readonly: isReadOnlyMode ? true : !isShipper,
//       },
//       "Appointment Date": {
//         ...prev["Appointment Date"],
//         type:  isReadOnlyMode ? "text" : (isEditMode ? "date" : "text"),
//         value: date
//           ? (isEditMode && !isReadOnlyMode
//               ? date
//               : format(parseISO(date), "MMM dd, yyyy"))
//           : "—",
//         minDate: calculatedMinDate,
//         readonly: isReadOnlyMode,
//       },
//     }));
//   }, [
//     selectedLocation, selectedWarehouse, selectedDocks,
//     locationOptions, warehouseOptions, dockOptions,
//     date, userType, isEditMode, isShipper, warehouseFieldType,
//     shipmentData, isReadOnlyMode,
//   ]);

//   // Fetch location from ref
//   useEffect(() => {
//     if (!appointmentData?.location) return;
//     const loadLocation = async () => {
//       try {
//         const loc = await fetchLocationByRef(appointmentData.location);
//         if (loc) { setSelectedLocation(loc); setLocationQuery(loc.locationName); }
//       } catch (err) { console.error("Failed to fetch location by locationRef:", err); }
//     };
//     loadLocation();
//   }, [appointmentData?.location]);

//   // Fetch locations (Create Mode)
//   useEffect(() => {
//     if (appointmentData?.location || userType !== "Shipper" || isEditMode) return;
//     const fetchLocations = async () => {
//       try {
//         const res = await axios.get(
//           `${process.env.REACT_APP_API_BASE_URL}/api/locations/by-office-code/${officeCode}`
//         );
//         setLocationOptions(res.data || []);
//       } catch (err) { console.error("Failed to fetch locations", err); setLocationOptions([]); }
//     };
//     fetchLocations();
//   }, [appointmentData?.location, userType, isEditMode, officeCode]);

//   // Fetch warehouse
//   useEffect(() => {
//     if (!appointmentData?.warehouse) return;
//     const loadWarehouse = async () => {
//       try {
//         const warehouse = await fetchLocationByRef(appointmentData.warehouse);
//         if (warehouse && typeof warehouse === 'object') {
//           setWarehouseOptions([warehouse]);
//           setSelectedWarehouse(warehouse);
//           setWarehouseQuery(warehouse.locationName);
//         }
//       } catch (err) { console.error("Failed to fetch warehouse:", err); }
//     };
//     loadWarehouse();
//   }, [appointmentData?.warehouse]);

//   // Fetch warehouses when location is selected
//   useEffect(() => {
//     if (!selectedLocation?.id) return;
//     const fetchWarehouses = async () => {
//       try {
//         const response = await axios.get(
//           `${process.env.REACT_APP_API_BASE_URL}/api/locations/children/by-id?parentId=${selectedLocation.id}`
//         );
//         setWarehouseOptions(response.data);
//         setFilteredWarehouses(response.data);
//         const matchedWarehouse = response.data.find(
//           (wh) => wh.customLocationIdentifier === appointmentData?.customLocationIdentifier
//         );
//         if (matchedWarehouse) {
//           setSelectedWarehouse(matchedWarehouse);
//           setWarehouseQuery(matchedWarehouse.locationName);
//         } else if (!isEditMode && !appointmentData?.warehouse) {
//           setSelectedWarehouse(null);
//           setWarehouseQuery("");
//         }
//       } catch (error) {
//         console.error("Failed to fetch warehouses:", error);
//         setWarehouseOptions([]);
//         setFilteredWarehouses([]);
//       }
//     };
//     fetchWarehouses();
//   }, [selectedLocation, appointmentData?.customLocationIdentifier, appointmentData?.warehouse, isEditMode]);

//   // Fetch dock
//   useEffect(() => {
//     const dockIdRaw = appointmentData?.dockNumber;
//     const dockId = Number(dockIdRaw);
//     if (!dockId || isNaN(dockId)) return;
//     const loadDock = async () => {
//       try {
//         const dock = await fetchDockById(dockId);
//         if (dock) { setDocksOptions([dock]); setSelectedDocks(dock); setDockQuery(dock.dockName); }
//       } catch (err) { console.error("Failed to fetch dock:", err); setDocksOptions([]); }
//     };
//     loadDock();
//   }, [appointmentData?.dockNumber]);

//   // Fetch docks when warehouse is selected
//   useEffect(() => {
//     if (!selectedWarehouse?.locationRef) { setDocksOptions([]); setSelectedDocks(null); return; }
//     const fetchDocks = async () => {
//       try {
//         const response = await axios.get(
//           `${process.env.REACT_APP_API_BASE_URL}/api/dock/docks/${selectedWarehouse.locationRef}`
//         );
//         setDocksOptions(response.data || []);
//         if (userType === "Carrier" && response.data.length > 0 && !isEditMode) {
//           setSelectedDocks(response.data[0]);
//           setDockQuery(response.data[0].dockName || "");
//         }
//       } catch (error) { console.error("Failed to fetch docks:", error); setDocksOptions([]); }
//     };
//     fetchDocks();
//   }, [selectedWarehouse, userType, isEditMode]);

//   // Auto-select dock in edit mode
//   useEffect(() => {
//     if (!isEditMode || !appointmentData || !dockOptions.length) return;
//     const matchingDock = dockOptions.find(
//       (dock) => String(dock.dockId) === String(appointmentData.dockNumber)
//     );
//     if (matchingDock && !selectedDocks) { setSelectedDocks(matchingDock); setDockQuery(matchingDock.dockName || ""); }
//   }, [dockOptions, appointmentData, isEditMode, selectedDocks]);

//   // Fetch available shipments for Shipper
//   useEffect(() => {
//     if (userType !== "Shipper") return;
//     const fetchShipmentOptions = async () => {
//       try {
//         const response = await axios.get(
//           `${process.env.REACT_APP_API_BASE_URL}/api/shipments/appointment-details`,
//           { params: { officeCode, page: 0, size: 10 } }
//         );
//         const uniqueShipments = [];
//         const seen = new Set();
//         for (const shipment of response.data.content) {
//           if (!seen.has(shipment.shipmentNumber)) {
//             seen.add(shipment.shipmentNumber);
//             uniqueShipments.push(shipment);
//           }
//         }
//         setAvailableShipments(uniqueShipments);
//       } catch (error) { console.error("Failed to fetch shipments:", error); }
//     };
//     fetchShipmentOptions();
//   }, [userType, officeCode]);

//   // Add appointment shipment to available shipments
//   useEffect(() => {
//     if (!appointmentData?.shipmentNumber) return;
//     const shipmentFromAppointmentData = {
//       shipmentNumber:   appointmentData.shipmentNumber,
//       partyName:        appointmentData.company || appointmentData.shipperName,
//       addressLine1:     appointmentData.addressLine1     || "",
//       addressLine2:     appointmentData.addressLine2     || "",
//       city:             appointmentData.city             || "",
//       zipCode:          appointmentData.zipCode          || "",
//       country:          appointmentData.country          || "",
//       state:            appointmentData.state            || "",
//       officeCode:       appointmentData.carrierOfficeCode|| "",
//       stopReasonCode:   appointmentData.stopReasonCode   || "",
//       poNumber:         appointmentData.poNumber         || "",
//       saleNumber:       appointmentData.saleNumber       || "",
//       mustPickUpBy:     appointmentData.mustPickUpBy     || "",
//       mustDeliverBy:    appointmentData.mustDeliverBy    || "",
//     };
//     setAvailableShipments((prev) => {
//       const isAlreadyAvailable = prev.some(
//         (s) => s.shipmentNumber === appointmentData.shipmentNumber
//       );
//       return isAlreadyAvailable ? prev : [shipmentFromAppointmentData, ...prev];
//     });
//   }, [appointmentData]);

//   // Fetch shipment data
//   useEffect(() => {
//     if (!appointmentData?.shipmentNumber) return;
//     const loadShipmentData = async () => {
//       try {
//         const ocForShipment =
//           appointmentData?.shipperOfficeCode    ||
//           appointmentData?.officeCodeShipper    ||
//           appointmentData?.shipmentOfficeCode   ||
//           Cookies.get("officeCode");
//         const data = await getShipmentByShipmentNum(appointmentData.shipmentNumber, ocForShipment);
//         if (data) {
//           setShipmentData(data);
//           console.log("Fetched shipment data: ", data);
//           const stopReasonFromStops = extractStopReasonFromShipmentData(data, appointmentData?.stopNumber);
//           setShipments((prev) =>
//             prev.map((s) =>
//               s.shipmentNumber === data.shipmentNumber
//                 ? {
//                     ...s,
//                     stopReasonCode: data.stopReasonCode || stopReasonFromStops || s.stopReasonCode,
//                     requestType:    data.requestType    || s.requestType,
//                   }
//                 : s
//             )
//           );
//         }
//       } catch (err) { console.error("Failed to fetch shipment data:", err); }
//     };
//     loadShipmentData();
//   }, [appointmentData?.shipmentNumber, officeCode]);

//   // Reset form
//   const resetAppointmentForm = () => {
//     setDate(""); setSelectedSlot(null); setSelectedLocation(null); setLocationQuery("");
//     setSelectedWarehouse(null); setFilteredWarehouses([]); setWarehouseOptions([]);
//     setSelectedDocks(null); setDockQuery(""); setDocksOptions([]);
//     setSelectedDoor(null); setDoorQuery(""); setDoorOptions([]);
//     setShipments([{
//       shipmentNumber: "", stopNumber: 1, company: "",
//       addressLine1: "", addressLine2: "", city: "", zipCode: "",
//       country: "", state: "", carrierName: "", officeCodeCarrier: "",
//       officeCodeShipper: "", poNumber: "", saleNumber: "", stopReasonCode: "",
//     }]);
//     setAppointmentCarrier({ driverName: "", carrierName: "", trailerNumber: "" });
//     setSlots([]);
//   };

//   // Centralized function to fetch and map dock slots w/ race condition protection
//   const fetchAndMapDockSlots = useCallback(async (locationRef, dateStr, fetchId, fetchIdRef) => {
//     try {
//       const data = await fetchWarehouseSlotsAvailability(locationRef, dateStr);
//       if (fetchId !== fetchIdRef.current) {
//         console.log(`Ignoring stale slots response for fetchId ${fetchId}`);
//         return null;
//       }
//       return (data || []).map((item) => {
//         const matchedDock = dockOptions.find(
//           (dock) => String(dock.dockId) === String(item.dockId)
//         );
//         const dock = matchedDock || {
//           dockId: item.dockId,
//           dockName: item.dockName,
//           locationRef: item.locationRefId,
//         };
//         return { dock, slots: Array.isArray(item.slots) ? item.slots : [] };
//       });
//     } catch (error) {
//       if (fetchId === fetchIdRef.current) console.error("Error fetching dock slots:", error);
//       throw error;
//     }
//   }, [dockOptions]);

//   const getSlotsForDock = useCallback((mappedData, dockId) => {
//     if (!dockId || !mappedData) return [];
//     const currentDockEntry = mappedData.find(
//       ({ dock }) => String(dock.dockId) === String(dockId)
//     );
//     return currentDockEntry?.slots || [];
//   }, []);

//   // Find available slots
//   const handleFindSlots = useCallback(async () => {
//     const today     = new Date();
//     today.setHours(0, 0, 0, 0);
//     const inputDate = new Date(date);

//     if (isEditMode && inputDate < today && selectedSlot) {
//       notify.warning({
//         title: "Invalid Date",
//         message: "Appointment cannot be scheduled to a past date. Please select today or a future date.",
//       });
//       return;
//     }

//     if (!selectedLocation?.locationRef) {
//       notify.warning({ title: "Missing Location", message: "Please select a Location before continuing." });
//       return;
//     }

//     if (warehouseOptions.length > 0 && !selectedWarehouse?.locationRef) {
//       notify.warning({ title: "Missing Warehouse", message: "Please select a Warehouse before continuing." });
//       return;
//     }

//     if (dockOptions.length > 0 && !selectedDocks?.dockId) {
//       notify.warning({ title: "Missing Dock", message: "Please select a Dock before continuing." });
//       return;
//     }

//     const fetchId = ++slotsFetchIdRef.current;
//     try {
//       const mapped = await fetchAndMapDockSlots(
//         selectedWarehouse.locationRef, date, fetchId, slotsFetchIdRef
//       );
//       if (!mapped) return;
//       setAllDockSlots(mapped);
//       const availableSlots = getSlotsForDock(mapped, selectedDocks.dockId);
//       setSlots(availableSlots);
//       if (isEditMode && appointmentData?.startTime) {
//         const appointmentStart = appointmentData.startTime.split("T")[1]?.substring(0, 5);
//         const matchingSlot = availableSlots.find((slot) => slot.startTime === appointmentStart);
//         if (matchingSlot) setSelectedSlot(matchingSlot);
//       }
//     } catch (error) {
//       if (fetchId === slotsFetchIdRef.current) { console.error("Error fetching slots:", error); setSlots([]); }
//     }
//   }, [
//     date, selectedLocation, selectedWarehouse, selectedDocks,
//     warehouseOptions, dockOptions, isEditMode, appointmentData,
//     fetchAndMapDockSlots, getSlotsForDock,
//   ]);

//   const refreshAndValidateSelectedSlot = useCallback(async () => {
//     if (!date || !selectedWarehouse?.locationRef || !selectedDocks?.dockId || !selectedSlot) return true;
//     const fetchId = ++slotsFetchIdRef.current;
//     try {
//       const mapped = await fetchAndMapDockSlots(
//         selectedWarehouse.locationRef, date, fetchId, slotsFetchIdRef
//       );
//       if (!mapped) return true;
//       setAllDockSlots(mapped);
//       const availableSlots = getSlotsForDock(mapped, selectedDocks.dockId);
//       setSlots(availableSlots);
//       const stillAvailable = availableSlots.some(
//         (slot) => slot.startTime === selectedSlot.startTime && slot.endTime === selectedSlot.endTime
//       );
//       if (!stillAvailable) {
//         setSelectedSlot(null);
//         notify.error({ title: "Slot Unavailable", message: "The selected slot was just taken. Please pick another." });
//       }
//       return stillAvailable;
//     } catch (err) {
//       if (fetchId === slotsFetchIdRef.current) console.error("Failed to refresh slots before submit", err);
//       return true;
//     }
//   }, [date, selectedWarehouse?.locationRef, selectedDocks?.dockId, selectedSlot, fetchAndMapDockSlots, getSlotsForDock]);

//   // Fetch slots for every dock in the warehouse
//   const fetchAllDockSlots = useCallback(async () => {
//     if (isCancelled) return;
//     if (!date || !selectedWarehouse?.locationRef) return;
//     const fetchId = ++allSlotsFetchIdRef.current;
//     setIsAllSlotsLoading(true);
//     setAllSlotsError(null);
//     try {
//       const mapped = await fetchAndMapDockSlots(
//         selectedWarehouse.locationRef, date, fetchId, allSlotsFetchIdRef
//       );
//       if (!mapped) { setIsAllSlotsLoading(false); return; }
//       setAllDockSlots(mapped);
//       if (selectedDocks?.dockId) {
//         const availableSlots = getSlotsForDock(mapped, selectedDocks.dockId);
//         setSlots(availableSlots);
//       }
//     } catch (err) {
//       if (fetchId === allSlotsFetchIdRef.current) {
//         console.error("Failed to fetch slots for all docks", err);
//         setAllDockSlots([]);
//         setAllSlotsError(err?.response?.data?.message || err?.message || "Unable to load slots for docks.");
//       }
//     } finally {
//       if (fetchId === allSlotsFetchIdRef.current) setIsAllSlotsLoading(false);
//     }
//   }, [date, isCancelled, selectedWarehouse?.locationRef, selectedDocks?.dockId, fetchAndMapDockSlots, getSlotsForDock]);

//   const handleSelectSlotFromModal = (dock, slot) => {
//     if (isReadOnlyMode) return;
//     const now = new Date();
//     const [year, month, day]   = date.split('-').map(Number);
//     const [hours, minutes]     = slot.startTime.split(':').map(Number);
//     const slotDateTime = new Date(year, month - 1, day, hours, minutes);
//     if (slotDateTime < now) {
//       notify.warning({
//         title: "Invalid Time Slot",
//         message: "Cannot select a time slot in the past. Please choose a future time.",
//       });
//       return;
//     }
//     setSelectedDocks(dock);
//     setDockQuery(dock?.dockName || "");
//     setSelectedSlot(slot);
//     setShowAllSlotsModal(false);
//   };

//   // Auto-fetch slots when date, warehouse, or dock changes
//   useEffect(() => {
//     if (isCancelled) return;
//     if (!date || !selectedWarehouse || !selectedDocks) return;
//     shouldFetchSlotsRef.current = true;
//     const timeout = setTimeout(() => {
//       if (shouldFetchSlotsRef.current) { handleFindSlots(); shouldFetchSlotsRef.current = false; }
//     }, 400);
//     return () => { clearTimeout(timeout); shouldFetchSlotsRef.current = false; };
//   }, [date, selectedWarehouse?.locationRef, selectedDocks?.dockId]);

//   // Separate effect for all slots modal/inline
//   useEffect(() => {
//     if (!showAllSlotsModal && !showInlineAllSlots) return;
//     if (!date || !selectedWarehouse?.locationRef) return;
//     fetchAllDockSlots();
//   }, [showAllSlotsModal, showInlineAllSlots, date, selectedWarehouse?.locationRef]);

//   // Submit/Update appointment — blocked in read-only mode
//   const handleUpdate = async () => {
//     if (isReadOnlyMode) return;

//     if (isCancelled) {
//       notify.warning({
//         title: "Appointment Cancelled",
//         message: "This appointment is cancelled and cannot be updated.",
//       });
//       return;
//     }

//     const selectedShipment = selectedShipmentNumber
//       ? shipments.find((s) => s.shipmentNumber === selectedShipmentNumber)
//       : shipments[0];

//     setLoading(true);
//     try {
//       if (!selectedSlot) {
//         notify.warning({ title: "Missing Selection", message: "Please select a time slot before proceeding." });
//         setLoading(false);
//         return;
//       }
//       if (!selectedShipment) {
//         notify.warning({ title: "No Shipment Selected", message: "Please choose a shipment before continuing." });
//         setLoading(false);
//         return;
//       }

//       const inferredReasonFromRequestType = (() => {
//         const rt = (
//           selectedShipment.requestType ||
//           appointmentData?.requestType  ||
//           shipmentData?.requestType     ||
//           ""
//         ).trim().replace("_", " ").replace("-", " ").toUpperCase();
//         if (rt === "DT" || rt === "DROP TRAILER" || rt === "DROPTRAILER" || (rt.includes("DROP") && rt.includes("TRAILER"))) return "DT";
//         if (rt === "LL" || rt === "LIVE LOAD"    || rt === "LIVELOAD"    || (rt.includes("LIVE") && rt.includes("LOAD")))    return "LL";
//         return "";
//       })();

//       const stopReasonFromShipmentStops = extractStopReasonFromShipmentData(
//         shipmentData,
//         selectedShipment?.stopNumber ?? appointmentData?.stopNumber
//       );

//       const rawStopReason = (
//         selectedShipment.stopReasonCode ||
//         appointmentData?.stopReasonCode  ||
//         shipmentData?.stopReasonCode     ||
//         stopReasonFromShipmentStops      ||
//         inferredReasonFromRequestType    ||
//         ""
//       ).trim().toUpperCase();

//       const isDropTrailer =
//         rawStopReason === "DT" || rawStopReason === "DROP TRAILER" || rawStopReason === "DROPTRAILER" ||
//         (rawStopReason.includes("DROP") && rawStopReason.includes("TRAILER"));
//       const requestType = isDropTrailer ? "DROP_TRAILER" : "LIVE_LOAD";

//       const appointmentPayload = {
//         startTime:        `${date}T${selectedSlot.startTime}`,
//         endTime:          `${date}T${selectedSlot.endTime}`,
//         location:         selectedLocation.locationRef,
//         warehouse:        selectedWarehouse.locationRef,
//         dockNumber:       selectedDocks.dockId,
//         doorNumber:       selectedDoor?.doorId,
//         driverName:       appointmentCarrier.driverName,
//         trailerNumber:    appointmentCarrier.trailerNumber,
//         shipmentNumber:   selectedShipment.shipmentNumber,
//         stopNumber:       selectedShipment.stopNumber,
//         companyName:      selectedShipment.company,
//         addressLine1:     selectedShipment.addressLine1,
//         addressLine2:     selectedShipment.addressLine2,
//         city:             selectedShipment.city,
//         zipCode:          selectedShipment.zipCode,
//         country:          selectedShipment.country,
//         state:            selectedShipment.state,
//         officeCodeShipper:selectedShipment?.officeCodeShipper,
//         officeCodeCarrier:userType === "Carrier" ? officeCode : selectedShipment.officeCodeCarrier,
//         carrierName:      selectedShipment.carrierName,
//         poNumber:         selectedShipment.poNumber,
//         saleNumber:       selectedShipment.saleNumber,
//         stopReasonCode:   rawStopReason,
//         requestType,
//         isDropTrailer,
//       };

//       const slotStillFree = await refreshAndValidateSelectedSlot();
//       if (!slotStillFree) { setLoading(false); return; }

//       const token = Cookies.get("authToken");
//       if (isAddMode) {
//         await axios.post(
//           `${process.env.REACT_APP_API_BASE_URL}/api/appointment/addAppointment/`,
//           appointmentPayload,
//           { headers: { Authorization: `Bearer ${token}`, "Office-Code": officeCode } }
//         );
//       } else {
//         await axios.put(
//           `${process.env.REACT_APP_API_BASE_URL}/api/appointment/${appointmentData.appointmentId}/update`,
//           appointmentPayload,
//           { headers: { Authorization: `Bearer ${token}`, "Office-Code": officeCode } }
//         );
//       }

//       notify.success({
//         title:   isAddMode ? "Appointment Added" : "Appointment Updated",
//         message: `Saved successfully as ${requestType.replace("_", " ")} (${isDropTrailer ? "Drop Trailer" : "Live Load"}).`,
//       });

//       dispatch(removeTab({ tabIndex: activeTab }));
//       dispatch(setActiveTab({ index: 0 }));
//       resetAppointmentForm();
//     } catch (error) {
//       console.error("Error while updating appointment:", error);
//       if (error?.response?.status === 409) {
//         await refreshAndValidateSelectedSlot();
//         notify.error({ title: "Slot Unavailable", message: "The selected slot was just taken. Please choose another time." });
//         return;
//       }
//       notify.error({
//         title:   isAddMode ? "Add Failed" : "Update Failed",
//         message: error?.response?.data?.message || `Failed to ${isAddMode ? 'add' : 'update'} appointment. Please try again.`,
//       });
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Shipment field configuration
//   const mustPickUpBy  = formatDateOnly(shipmentData?.pickupDate)  ?? "—";
//   const mustDeliverBy = formatDateOnly(shipmentData?.deliveryDate) ?? "—";

//   const shipmentFieldConfig = {
//     shipmentNumber:  { label: "Shipment Number",      value: appointmentData.shipmentNumber,                                                inputType: "text", isReadOnly: true },
//     stopNumber:      { label: "Stop Number",          value: appointmentData.stopNumber,                                                    inputType: "number" },
//     poNumber:        { label: "PO Number",            value: appointmentData.poNumber,                                                      inputType: "text"   },
//     salesOrderNumber:{ label: "SO Number",            value: appointmentData?.salesOrderNumber ?? shipmentData?.salesOrderNumber ?? '-',    inputType: "text"   },
//     shipperOfficeCode:{ label: "Office Code",         value: appointmentData.officeCodeShipper,                                             inputType: "text"   },
//     companyName:     { label: "Company",              value: appointmentData.companyName,                                                   inputType: "text"   },
//     addressLine1:    { label: "Address Line 1",       value: appointmentData.addressLine1,                                                  inputType: "text"   },
//     addressLine2:    { label: "Address Line 2",       value: appointmentData.addressLine2,                                                  inputType: "text"   },
//     city:            { label: "City",                 value: appointmentData.city,                                                          inputType: "text"   },
//     state:           { label: "State",                value: appointmentData.state,                                                         inputType: "text"   },
//     zipCode:         { label: "Zip Code",             value: appointmentData.zipCode,                                                       inputType: "text"   },
//     country:         { label: "Country",              value: appointmentData.country,                                                       inputType: "text"   },
//     carrierName:     { label: "Carrier",              value: appointmentData.carrierName,                                                   inputType: "text", isReadOnly: true },
//     mustPickUpBy:    { label: "Planned Pickup Date",  value: mustPickUpBy,                                                                  inputType: "text"   },
//     mustDeliverBy:   { label: "Planned Delivery Date",value: mustDeliverBy,                                                                 inputType: "text"   },
//   };

//   // ── Helpers for slot rendering ─────────────────────────────────────────────
//   const isSlotSelected = (dock, slot) =>
//     selectedSlot?.startTime === slot.startTime &&
//     String(selectedDocks?.dockId) === String(dock.dockId);

//   /**
//    * Returns Tailwind classes for a slot button.
//    * In read-only mode the cursor is default and no hover effect is shown.
//    */
//   const slotButtonClasses = (dock, slot) => {
//     const selected = isSlotSelected(dock, slot);
//     const base     = "border rounded-md px-3 py-2 text-sm flex items-center justify-between transition";

//     if (isReadOnlyMode) {
//       return selected
//         ? `${base} bg-[#223688] text-white border-[#223688] cursor-default`
//         : `${base} border-gray-300 text-gray-500 cursor-default bg-gray-50`;
//     }

//     return selected
//       ? `${base} bg-[#223688] text-white border-[#223688]`
//       : `${base} hover:bg-[#eef1ff] border-[#223688] text-[#223688]`;
//   };

//   // ── Render ─────────────────────────────────────────────────────────────────
//   return (
//     <>
//       <div className="w-full h-full flex flex-col">
//         <div
//           ref={headerRef}
//           data-app-sticky-header
//           className="sticky top-0 z-10 bg-white shadow-md w-full"
//         >
//           <StickyHeader
//             leftLabel="Appointment Details"
//             infoData={infoData}
//             mode={null}
//             onInfoChange={handleInfoChange}
//             templates={[]}
//             onSelectTemplate={() => {}}
//             // Hide action buttons entirely in read-only mode
//             buttons={
//               isEditMode
//                 ? [
//                     {
//                       label:    isAddMode ? (loading ? "Adding..." : "Add Appointment") : (loading ? "Updating..." : "Update Appointment"),
//                       onClick:  handleUpdate,
//                       disabled: loading || isCancelled,
//                       type:     "primary",
//                     },
//                   ]
//                 : []
//             }
//             saveTemplateConfig={null}
//             showStatusBlink={false}
//           />
//         </div>

//         <div className="bg-white shadow-fluid-card p-fluid-3 space-y-fluid-3">

//           {/* ── Read-only banner ──────────────────────────────────────────── */}
//           {isReadOnlyMode && (
//             <div className="flex items-center gap-2 rounded-md border border-gray-300 bg-gray-50 text-gray-700 px-3 py-2 text-sm">
//               <Lock className="w-4 h-4 shrink-0 text-gray-500" aria-hidden="true" />
//               <span>This appointment is in <strong>read-only</strong> mode while in-transit. No changes can be made.</span>
//             </div>
//           )}

//           {isCancelled && (
//             <div className="rounded-md border border-red-300 bg-red-50 text-red-800 px-3 py-2 text-sm">
//               This appointment has been cancelled. Details are read-only.
//             </div>
//           )}

//           <div className="flex items-center justify-between">
//             <h2 className="text-lg font-semibold text-gray-900">Appointment Summary</h2>
//             <div className="flex items-center gap-3">
//               {(() => {
//                 const typeInfo = deriveTypeInfo();
//                 const icon = typeInfo.isDropTrailer
//                   ? <Package className="w-4 h-4" />
//                   : <Truck   className="w-4 h-4" />;
//                 const colorClasses = typeInfo.isDropTrailer
//                   ? "bg-orange-100 text-orange-800 border-orange-200"
//                   : "bg-emerald-100 text-emerald-800 border-emerald-200";
//                 return (
//                   <span className={`inline-flex items-center gap-2 px-3 py-1 rounded-full text-sm font-semibold border ${colorClasses}`}>
//                     {icon}
//                     {typeInfo.label}
//                   </span>
//                 );
//               })()}
//             </div>
//           </div>

//           {/* ── All Dock Slots ──────────────────────────────────────────────── */}
//           <ExpandableHeader
//             headerSection="All Dock Slots"
//             headerLabel=""
//             headerType="secondary"
//             disableToggle
//             initiallyExpanded
//           >
//             <div className="border-t border-gray-200 p-4 bg-white shadow-sm max-h-[40rem] overflow-y-auto">
//               {isCancelled ? (
//                 <div className="text-sm text-red-700">
//                   Slot selection is unavailable because this appointment has been cancelled.
//                 </div>
//               ) : (
//                 <>
//                   <div className="mb-3 grid grid-cols-1 sm:grid-cols-5 gap-3">
//                     <DisplayDetail
//                       label="Scheduled Date"
//                       value={
//                         appointmentData?.startTime
//                           ? formattedTime(appointmentData.startTime, "EEEE, MMMM d, yyyy")
//                           : "N/A"
//                       }
//                     />
//                     <DisplayDetail
//                       label="Scheduled Start Time"
//                       value={
//                         appointmentData?.startTime
//                           ? formatSlotTime(trimTime(appointmentData.startTime))
//                           : "N/A"
//                       }
//                     />
//                   </div>

//                   {(!date || !selectedWarehouse?.locationRef || !dockOptions.length) && (
//                     <div className="text-sm text-gray-600">Select a date to view docks slots.</div>
//                   )}
//                   {isAllSlotsLoading && <Loader message="Loading slots..." compact />}
//                   {allSlotsError && (
//                     <div className="text-sm text-red-600">{allSlotsError}</div>
//                   )}

//                   {!isAllSlotsLoading && !allSlotsError && allDockSlots.length > 0 && (
//                     <div className="space-y-3">
//                       {/* Optional read-only hint above slot grid */}
//                       {isReadOnlyMode && (
//                         <p className="text-xs text-gray-500 italic">
//                           Slots are shown for reference only and cannot be changed in read-only mode.
//                         </p>
//                       )}
//                       {allDockSlots.map(({ dock, slots: dockSlots }) => (
//                         <div key={dock.dockId} className="p-fluid-1">
//                           <div className="flex items-center justify-between mb-2">
//                             <span className="text-sm font-semibold text-gray-800">
//                               {dock.dockName || `Dock ${dock.dockId}`}
//                             </span>
//                             <span className="text-xs text-gray-500">{dockSlots?.length || 0} slots</span>
//                           </div>
//                           <div className="grid grid-cols-2 sm:grid-cols-4 md:grid-cols-6 lg:grid-cols-8 gap-2">
//                             {Array.isArray(dockSlots) && dockSlots.length > 0 ? (
//                               dockSlots.map((slot) => (
//                                 <button
//                                   key={`${dock.dockId}-${slot.startTime}`}
//                                   onClick={() => handleSelectInlineSlot(dock, slot, dockSlots)}
//                                   // Disable button interaction in read-only mode
//                                   disabled={isReadOnlyMode}
//                                   aria-disabled={isReadOnlyMode}
//                                   className={slotButtonClasses(dock, slot)}
//                                 >
//                                   <span className="font-medium">
//                                     {formatSlotTime(slot.startTime)}
//                                   </span>
//                                   {!isReadOnlyMode && (
//                                     <span className="text-[11px] text-gray-500 ml-3">Select</span>
//                                   )}
//                                 </button>
//                               ))
//                             ) : (
//                               <div className="text-xs text-red-600 col-span-full">
//                                 No available slots for this dock.
//                               </div>
//                             )}
//                           </div>
//                         </div>
//                       ))}
//                     </div>
//                   )}

//                   {!isAllSlotsLoading && !allSlotsError && allDockSlots.length === 0 &&
//                     date && selectedWarehouse?.locationRef && dockOptions.length > 0 && (
//                       <div className="text-sm text-gray-600">No docks returned slots.</div>
//                     )}
//                 </>
//               )}
//             </div>
//           </ExpandableHeader>

//           {/* ── Shipment Details ──────────────────────────────────────────── */}
//           <ExpandableHeader
//             headerSection="Shipment"
//             headerLabel={
//               appointmentData.shipmentNumber ? (
//                 <button
//                   type="button"
//                   onClick={() => {
//                     const shipmentNumber = appointmentData?.shipmentNumber;
//                     if (!shipmentNumber) return;
//                     const shipmentOfficeCode =
//                       shipmentData?.officeCode              ||
//                       appointmentData?.officeCodeShipper    ||
//                       appointmentData?.shipmentOfficeCode   ||
//                       appointmentData?.officeCode           ||
//                       Cookies.get("officeCode");
//                     dispatch(addShipmentTab({
//                       id: `view-${shipmentNumber}-${Date.now()}`,
//                       name: `${shipmentNumber}`,
//                       contentType: "shipmentView",
//                       shipmentNumber,
//                       shipmentOfficeCode,
//                       isDynamic: true,
//                       createdAt: Date.now(),
//                     }));
//                     navigate("/dashboard/shipments");
//                   }}
//                   className="text-white underline decoration-white decoration-2 underline-offset-2"
//                 >
//                   {appointmentData.shipmentNumber}
//                 </button>
//               ) : ""
//             }
//             icon={Truck}
//             headerType="secondary"
//           >
//             <div className="px-4 py-3 mb-2">
//               <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-2">
//                 {Object.keys(shipmentFieldConfig).map((key) => {
//                   const config = shipmentFieldConfig[key];
//                   // In read-only mode every shipment field is non-editable
//                   const isReadOnly = isReadOnlyMode ? true : (config.isReadOnly ?? true);
//                   return (
//                     <DisplayDetail
//                       key={key}
//                       label={config.label}
//                       value={config.value}
//                       inputType={config.inputType}
//                       isEditable={isReadOnlyMode ? false : isEditMode}
//                       isReadOnly={isReadOnly}
//                     />
//                   );
//                 })}
//               </div>
//             </div>
//           </ExpandableHeader>

//           {/* ── Carrier Details ───────────────────────────────────────────── */}
//           <ExpandableHeader
//             headerSection="Carrier"
//             headerLabel={`${appointmentData.carrierName ? `\u00A0${appointmentData.carrierName}` : ''}`}
//             icon={Package}
//             headerType="secondary"
//           >
//             <div className="px-4 py-3 mb-2">
//               <div className="grid grid-cols-2 md:grid-cols-4 lg:grid-cols-3 gap-2">
//                 {Object.keys(carrierFieldConfig).map((key) => {
//                   const config = carrierFieldConfig[key];
//                   // In read-only mode all carrier fields are non-editable
//                   const isReadOnly = isReadOnlyMode ? true : (config.isReadOnly ?? false);
//                   return (
//                     <DisplayDetail
//                       key={key}
//                       label={config.label}
//                       value={config.value}
//                       inputType={config.inputType}
//                       isEditable={isReadOnlyMode ? false : isEditMode}
//                       isReadOnly={isReadOnly}
//                       onChange={(e) => {
//                         // Guard: no mutations in read-only mode
//                         if (!isEditMode || isReadOnlyMode || config.isReadOnly) return;
//                         const newValue  = e?.target?.value ?? e;
//                         const finalValue = config.inputType === "number" ? Number(newValue) : newValue;
//                         setAppointmentCarrier((prev) => ({ ...prev, [key]: finalValue }));
//                       }}
//                     />
//                   );
//                 })}
//               </div>
//             </div>
//           </ExpandableHeader>

//         </div>
//       </div>

//       {/* ── Modal: Show all dock slots for a warehouse ─────────────────────── */}
//       {showAllSlotsModal && (
//         <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 p-4">
//           <div className="bg-white rounded-lg shadow-2xl w-full max-w-5xl max-h-[80vh] overflow-hidden">
//             <div className="flex items-center justify-between px-5 py-3 border-b border-gray-200">
//               <div>
//                 <h3 className="text-lg font-semibold text-gray-900">Available Slots by Dock</h3>
//                 <p className="text-sm text-gray-500">
//                   {date
//                     ? `For ${format(parseISO(date), "EEEE, MMM d, yyyy")}`
//                     : "Select a date to view slots"}
//                 </p>
//               </div>
//               <button
//                 type="button"
//                 onClick={() => setShowAllSlotsModal(false)}
//                 className="text-gray-500 hover:text-gray-700"
//               >
//                 <X size={18} />
//               </button>
//             </div>

//             <div className="p-5 space-y-4 overflow-y-auto max-h-[70vh]">
//               {isAllSlotsLoading && (
//                 <div className="flex items-center justify-center py-10 text-gray-600">
//                   <Loader message="Loading slots..." />
//                 </div>
//               )}
//               {allSlotsError && (
//                 <div className="bg-red-50 text-red-700 border border-red-200 rounded-md px-4 py-3 text-sm">
//                   {allSlotsError}
//                 </div>
//               )}
//               {!isAllSlotsLoading && !allDockSlots.length && !allSlotsError && (
//                 <div className="text-sm text-gray-600">
//                   No docks returned slots. Try another date or warehouse.
//                 </div>
//               )}

//               {allDockSlots.map(({ dock, slots: dockSlots }) => (
//                 <div key={dock.dockId} className="border border-gray-200 rounded-md p-4 shadow-sm">
//                   <div className="flex items-center justify-between mb-3">
//                     <div className="flex items-center gap-2">
//                       <div className="px-2 py-1 rounded bg-gray-100 text-xs font-semibold text-gray-700">
//                         Dock #{dock.dockId}
//                       </div>
//                       <span className="text-sm text-gray-800 font-medium">
//                         {dock.dockName || "Unnamed Dock"}
//                       </span>
//                     </div>
//                     <span className="text-xs text-gray-500">{dockSlots?.length || 0} slots</span>
//                   </div>

//                   <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-2">
//                     {Array.isArray(dockSlots) && dockSlots.length > 0 ? (
//                       dockSlots.map((slot) => (
//                         <button
//                           key={`${dock.dockId}-${slot.startTime}`}
//                           onClick={() => handleSelectSlotFromModal(dock, slot)}
//                           disabled={isReadOnlyMode}
//                           className={`border rounded-md px-3 py-2 text-sm flex items-center justify-between transition ${
//                             isReadOnlyMode
//                               ? "border-gray-300 text-gray-500 cursor-default bg-gray-50"
//                               : "hover:bg-[#eef1ff] border-[#223688] text-[#223688]"
//                           }`}
//                         >
//                           <span className="font-medium">{formatSlotTime(slot.startTime)}</span>
//                           {!isReadOnlyMode && (
//                             <span className="text-[11px] text-gray-500 ml-3">Select</span>
//                           )}
//                         </button>
//                       ))
//                     ) : (
//                       <div className="text-sm text-gray-500 col-span-full">
//                         No available slots for this dock.
//                       </div>
//                     )}
//                   </div>
//                 </div>
//               ))}
//             </div>
//           </div>
//         </div>
//       )}
//     </>
//   );
// };

// export default AppointmentForm;

import React, { useState, useRef, useEffect, useCallback } from "react";
import { format, parseISO } from "date-fns";
import Cookies from "js-cookie";

import { useAppointmentMode, useAppointmentData, useSlots, useAppointmentSubmit } from "./hooks";
import { buildShipmentFieldConfig, buildCarrierFieldConfig, buildInfoData } from "./fieldConfigs";
import { formatDateOnly, deriveTypeInfo, buildInitialShipments } from "./utils";
import {
  ReadOnlyBanner, CancelledBanner, CarrierDropTrailerBanner, AppointmentTypeBadge,
  DockSlotsSection, ShipmentSection, CarrierSection, AllSlotsModal,
} from "./components";
import notify from "../../../../../components/ACS-Dashboard/ACS-Blocks/Toast";
import StickyHeader from "../../../../../components/ModuleCommon/StickyHeader/StickyHeader";

export const APPOINTMENT_MODES = { ADD: "add", UPDATE: "update", READONLY: "readonly" };

/**
 * AppointmentForm  (orchestrator)
 *
 * Wires hooks together, derives display data, renders composed sub-components.
 *
 * Props:
 *  - appointmentData  object  — appointment record to display / edit
 *  - userType         string  — "Shipper" | "Carrier"
 *  - mode             string  — APPOINTMENT_MODES value (default: "update")
 */
const AppointmentForm = ({ appointmentData, userType, mode = APPOINTMENT_MODES.UPDATE }) => {
  const isShipper = userType === "Shipper";
  const headerRef = useRef(null);

  // ── 1. Mode (re-evaluated once shipmentData loads) ───────────────────────────
  const [shipmentDataForMode, setShipmentDataForMode] = useState(null);
  // Carriers can only view drop trailer appointments, so derive the type early
  // (seeded from appointmentData while shipmentData loads) to lock the form.
  const { isDropTrailer } = deriveTypeInfo(shipmentDataForMode, appointmentData);
  const { isAddMode, isReadOnlyMode, isEditMode, isCarrierDropTrailer } = useAppointmentMode(
    mode,
    shipmentDataForMode,
    { userType, isDropTrailer }
  );
  const warehouseFieldType = isShipper ? (isEditMode ? "dropdown" : "text") : "text";

  // ── 2. Remote data ───────────────────────────────────────────────────────────
  const data = useAppointmentData({ appointmentData, userType, isEditMode, isShipper });
  useEffect(() => { setShipmentDataForMode(data.shipmentData); }, [data.shipmentData]);

  // ── 3. Local form state ──────────────────────────────────────────────────────
  const [date, setDate] = useState(appointmentData?.startTime?.split("T")[0] || "");
  useEffect(() => {
    if (appointmentData?.startTime) setDate(appointmentData.startTime.split("T")[0]);
  }, [appointmentData?.startTime]);

  const [shipments, setShipments] = useState(() => buildInitialShipments(appointmentData));
  const [selectedShipmentNumber, setSelectedShipmentNumber] = useState(
    appointmentData?.shipmentNumber || ""
  );

  const isCancelled =
    appointmentData?.cancelled ||
    appointmentData?.status === "CANCELLED" ||
    appointmentData?.fetchError === "not_found";

  // ── 4. Slots ─────────────────────────────────────────────────────────────────
  const slots = useSlots({
    date,
    selectedWarehouse: data.selectedWarehouse,
    selectedDocks:     data.selectedDocks,
    dockOptions:       data.dockOptions,
    isReadOnlyMode,
    isEditMode,
    isCancelled,
    appointmentData,
  });

  // Auto-fetch on dependency change (debounced)
  const shouldFetchRef = useRef(true);
  useEffect(() => {
    if (isCancelled || !date || !data.selectedWarehouse || !data.selectedDocks) return;
    shouldFetchRef.current = true;
    const t = setTimeout(() => {
      if (shouldFetchRef.current) { slots.handleFindSlots(); shouldFetchRef.current = false; }
    }, 400);
    return () => { clearTimeout(t); shouldFetchRef.current = false; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [date, data.selectedWarehouse?.locationRef, data.selectedDocks?.dockId]);

  useEffect(() => {
    if (!slots.showAllSlotsModal && !slots.showInlineAllSlots) return;
    if (!date || !data.selectedWarehouse?.locationRef) return;
    slots.fetchAllDockSlots();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [slots.showAllSlotsModal, slots.showInlineAllSlots, date, data.selectedWarehouse?.locationRef]);

  // ── 5. Form reset ────────────────────────────────────────────────────────────
  const resetForm = useCallback(() => {
    setDate("");
    slots.setSelectedSlot(null);
    data.setSelectedLocation(null);  data.setLocationQuery("");
    data.setSelectedWarehouse(null); data.setWarehouseQuery("");
    data.setSelectedDocks(null);     data.setDockQuery("");
    data.setSelectedDoor(null);      data.setDoorQuery("");
    setShipments(buildInitialShipments(null));
    data.setAppointmentCarrier({ driverName: "", carrierName: "", trailerNumber: "" });
  }, [slots, data]);

  // ── 6. Submit ────────────────────────────────────────────────────────────────
  const { loading, handleSubmit } = useAppointmentSubmit({
    isAddMode, isReadOnlyMode, isCancelled, appointmentData,
    date,
    selectedLocation:  data.selectedLocation,
    selectedWarehouse: data.selectedWarehouse,
    selectedDocks:     data.selectedDocks,
    selectedDoor:      data.selectedDoor,
    selectedSlot:      slots.selectedSlot,
    shipments,
    selectedShipmentNumber,
    appointmentCarrier: data.appointmentCarrier,
    shipmentData:       data.shipmentData,
    userType,
    refreshAndValidateSelectedSlot: slots.refreshAndValidateSelectedSlot,
    resetForm,
  });

  // ── 7. Header info ───────────────────────────────────────────────────────────
  const calculatedMinDate = (() => {
    const stop = data.shipmentData?.shipmentStops?.find(
      (s) => s.stopName === data.selectedLocation?.locationName
    );
    const mustPickUpBy = formatDateOnly(stop?.scheduledGateIn) ?? null;
    const today = format(new Date(), "yyyy-MM-dd");
    return mustPickUpBy ? (mustPickUpBy > today ? mustPickUpBy : today) : today;
  })();

  const infoData = buildInfoData({
    selectedLocation:  data.selectedLocation,
    locationOptions:   data.locationOptions,
    selectedWarehouse: data.selectedWarehouse,
    warehouseOptions:  data.warehouseOptions,
    date, isReadOnlyMode, isEditMode, isShipper, warehouseFieldType,
    calculatedMinDate,
  });

  const handleInfoChange = (field, newValue) => {
    if (isReadOnlyMode) return;
    if (field === "Appointment Date") {
      const mustPickUpBy = formatDateOnly(data.shipmentData?.pickupDate);
      if (mustPickUpBy && mustPickUpBy !== "—" && newValue < mustPickUpBy) {
        notify.warning({
          title:   "Invalid Date",
          message: `The appointment date cannot be before the Planned Pickup Date (${format(parseISO(mustPickUpBy), "MMM dd, yyyy")}).`,
        });
        return;
      }
      setDate(newValue);
    }
    if (field === "Warehouse") {
      const selected = data.warehouseOptions.find((wh) => wh.locationName === newValue);
      if (selected) {
        data.setSelectedWarehouse(selected);
        data.setWarehouseQuery(selected.locationName);
        data.setSelectedDocks(null);
        data.setDockQuery("");
        slots.setSelectedSlot(null);
      }
    }
  };

  // ── 8. Slot selection bridges (hook needs setters from data hook) ─────────────
  const handleSelectInlineSlot = (dock, slot, slotsForDock) =>
    slots.handleSelectInlineSlot(dock, slot, slotsForDock, {
      setSelectedDocks: data.setSelectedDocks,
      setDockQuery:     data.setDockQuery,
    });

  const handleSelectSlotFromModal = (dock, slot) =>
    slots.handleSelectSlotFromModal(dock, slot, {
      setSelectedDocks: data.setSelectedDocks,
      setDockQuery:     data.setDockQuery,
    });

  // ── 9. Field configs ─────────────────────────────────────────────────────────
  const mustPickUpBy  = formatDateOnly(data.shipmentData?.pickupDate)  ?? "—";
  const mustDeliverBy = formatDateOnly(data.shipmentData?.deliveryDate) ?? "—";
  const shipmentFieldConfig = buildShipmentFieldConfig(appointmentData, mustPickUpBy, mustDeliverBy, data.shipmentData);
  const carrierFieldConfig  = buildCarrierFieldConfig(data.appointmentCarrier);
  const typeInfo            = deriveTypeInfo(data.shipmentData, appointmentData);

  // ── Render ───────────────────────────────────────────────────────────────────
  return (
    <>
      <div className="w-full h-full flex flex-col">
        <div ref={headerRef} data-app-sticky-header className="sticky top-0 z-10 bg-white shadow-md w-full">
          <StickyHeader
            leftLabel="Appointment Details"
            infoData={infoData}
            mode={null}
            onInfoChange={handleInfoChange}
            templates={[]}
            onSelectTemplate={() => {}}
            buttons={
              isEditMode
                ? [{
                    label:    isAddMode ? (loading ? "Adding…" : "Add Appointment") : (loading ? "Updating…" : "Update Appointment"),
                    onClick:  handleSubmit,
                    disabled: loading || isCancelled,
                    type:     "primary",
                  }]
                : []
            }
            saveTemplateConfig={null}
            showStatusBlink={false}
          />
        </div>

        <div className="bg-white shadow-fluid-card p-fluid-3 space-y-fluid-3">
          {isReadOnlyMode && !isCancelled &&
            (isCarrierDropTrailer ? <CarrierDropTrailerBanner /> : <ReadOnlyBanner />)}
          {isCancelled && <CancelledBanner />}

          <div className="flex items-center justify-between">
            <h2 className="text-lg font-semibold text-gray-900">Appointment Summary</h2>
            <AppointmentTypeBadge
              isDropTrailer={typeInfo.isDropTrailer}
              label={typeInfo.label}
              pending={!typeInfo.resolved}
            />
          </div>

          <DockSlotsSection
            appointmentData={appointmentData}
            isCancelled={isCancelled}
            isReadOnlyMode={isReadOnlyMode}
            allDockSlots={slots.allDockSlots}
            isAllSlotsLoading={slots.isAllSlotsLoading}
            allSlotsError={slots.allSlotsError}
            selectedSlot={slots.selectedSlot}
            selectedDocks={data.selectedDocks}
            onSelectSlot={handleSelectInlineSlot}
            date={date}
            selectedWarehouse={data.selectedWarehouse}
            dockOptions={data.dockOptions}
          />

          <ShipmentSection
            appointmentData={appointmentData}
            shipmentData={data.shipmentData}
            fieldConfig={shipmentFieldConfig}
            isReadOnlyMode={isReadOnlyMode}
            isEditMode={isEditMode}
          />

          <CarrierSection
            appointmentData={appointmentData}
            fieldConfig={carrierFieldConfig}
            isReadOnlyMode={isReadOnlyMode}
            isEditMode={isEditMode}
            onCarrierChange={(key, val) =>
              data.setAppointmentCarrier((prev) => ({ ...prev, [key]: val }))
            }
          />
        </div>
      </div>

      <AllSlotsModal
        isOpen={slots.showAllSlotsModal}
        onClose={() => slots.setShowAllSlotsModal(false)}
        date={date}
        allDockSlots={slots.allDockSlots}
        isLoading={slots.isAllSlotsLoading}
        error={slots.allSlotsError}
        isReadOnlyMode={isReadOnlyMode}
        onSelectSlot={handleSelectSlotFromModal}
      />
    </>
  );
};

export default AppointmentForm;